<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
           :title="$lang.Documents.Menu.Settings.Types"
           :showHelp="true"
           :showClearButton="true"
           :showSaveButton="true"
           v-on:Clear="onClear"
           v-on:Save="onSave">

      <div class="form-group row">
        <div class="col-md-12 mb-3">
          <label for="txtNome">{{$lang.Documents.LabelName}}:</label>
          <b-form-input type="text"
                        name="txtNome"
                        ref="nomeComp"
                        :placeholder="$lang.Documents.PlaceholderName"
                        :autofocus="true"
                        v-model="form.nome.value"
                        :maxlength="form.nome.maxlength"
                        :required="form.nome.required"
                        :state="form.nome.state" />
        </div>
      </div>

    </Forms>
    <Tables ref="tableGrid"
            :columns="[$lang.Documents.LabelName, $lang.Common.DataTable.Actions]"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
      <tr v-for="(obj, index) in this.objList" v-bind:key="index">
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nome" classCss="text-left" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>

<script>
import AddType from './addtype.js'
export default AddType
</script>



// WEBPACK FOOTER //
// src/views/private/operational/documents/components/type/addtype.vue